import { getEnvVariable } from "../../../../modules/environmentalList"

const GeneralsettingsEdit = {
    "type": "popup",
    "key": "GeneralsettingsEdit",
    "name": "GeneralsettingsEdit",
    anchor: 'right',
    open: false,
    aliases: {
        open: 'editOpen'
    },
    sharedValues: ['open'],
    container: {
        "addRoute": true,
        closepopup: true,
        closepopupval: 'settings',
        values: { editInfo: null, edit: false, createduplicate: false, fullscreen: false, back: false, allgriddata: null, navigation: null },
        mapValues: {
            header: [
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
            ],
            EditGeneralsettings: [
                { key: 'editInfo', name: 'editInfo' },
                { key: 'allgriddata', name: 'allgriddata' },
                { key: 'save', name: 'save' },
                { key: 'saveduplicate', name: 'saveduplicate' },
                { key: 'edit', name: 'edit' },
                { key: 'exitfullscreen', name: 'exitfullscreen' },
                { key: 'fullscreen', name: 'fullscreen' },
                { key: 'createduplicate', name: 'createduplicate' },
                { key: 'back', name: 'back' },
                { key: 'navigation', name: 'navigation' },]
        },
        mapActionsToEffects: {},
        layout: {
            group: [{
                order: 0,
                type: 'div',
                className: 'row',
                components: [{
                    name: 'header',
                    type: 'div',
                    className: 'col-12 ',
                    sub: {
                        type: 'div',
                        className: 'col-12',
                    }
                }],

            },


            {
                order: 1,
                type: 'div',
                className: 'row',
                components: [{
                    name: 'EditGeneralsettings',
                    type: 'div',
                    className: 'col-12 pl-5 pt-1',
                    sub: {
                        type: 'div',
                        className: 'col-12 pl-5 pt-1',
                    }
                }],

            },
            ]
        },

        components: {
            header: {
                name: "header",
                type: 'header',
                title: 'Settings',
                components: [
                    {
                        type: 'breadcrumbs',
                        items: [
                            { "link": "View/Edit Settings", "appendval": "Name", "materialicon": "settings", className: 'eps-breadcrumb-item ', class: 'text-light' },
                        ]
                    }
                ],
                layout: {},
                actions: [
                    {
                        type: 'icon',
                        icon: 'back',
                        name: 'back',
                        hideon: 'back',
                        hidevalue: false,
                        title: 'Back'
                    },

                    {
                        type: 'icon',
                        icon: 'edit',
                        name: 'edit',
                        hideon: 'createduplicate',
                        hideanother: 'edit',
                        hidevalue: true,
                        title: 'Edit Settings'
                    },
                    {
                        type: 'icon',
                        icon: 'duplicate',
                        name: 'createduplicate',
                        hideon: 'edit',
                        hideanother: 'createduplicate',
                        hidevalue: true,
                        title: 'Clone Settings'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'save',
                        hideon: 'edit',
                        hidevalue: false,
                        title: 'Save Settings'
                    },
                    {
                        type: 'icon',
                        icon: 'save',
                        name: 'saveduplicate',
                        hideon: 'createduplicate',
                        hidevalue: false,
                        title: 'Save Settings'
                    },
                    {
                        type: 'icon',
                        icon: 'previtem',
                        name: 'previtem',
                        hideon: 'previtem',
                        hidevalue: false,
                        title: 'Previous Item'
                    },
                    {
                        type: 'icon',
                        icon: 'nextitem',
                        name: 'nextitem',
                        hideon: 'nextitem',
                        hidevalue: false,
                        title: 'Next Item'
                    },
                    {
                        type: 'icon',
                        icon: 'fullscreen',
                        name: 'fullscreen',
                        hidevalue: false,
                        title: 'Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'exitfullscreen',
                        name: 'exitfullscreen',
                        hideon: 'fullscreen',
                        hidevalue: false,
                        title: 'Exit Full Screen'
                    },
                    {
                        type: 'icon',
                        icon: 'history',
                        name: 'history',
                        title: 'History',
                        hideon: 'history',
                        hidevalue: false,
                        historyurl: {
                            url: getEnvVariable('Admin') + `/api/AppSettings/history/{Id}?`,
                            "routeProps": [{ name: "TableName", key: "Id", },],
                            type: 'get',
                            saveAs: { key: 'data' }
                        }
                    },
                ],


            },
            EditGeneralsettings: {
                "type": "form",
                "key": "EditGeneralsettings",
                "name": "EditGeneralsettings",
                aliases: {
                    'editInfo': 'editInfo',
                    'allgriddata': 'allgriddata',  // 
                    'navigation': 'navigation'
                },
                sharedValues: ['editInfo', 'allgriddata', 'navigation', 'edit', 'createduplicate', 'exitfullscreen', 'fullscreen'],
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Name',
                                type: 'div',
                                className: 'col-md-10 col-12',
                                sub: {
                                    type: 'div',
                                    className: 'col-md-10 col-12',
                                }
                            }],

                        },

                        {
                            order: 1,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Description',
                                type: 'div',
                                className: 'col-md-10 col-12',
                                sub: {
                                    type: 'div',
                                    className: 'col-md-10 col-12',
                                }
                            },
                            ]
                        },
                        {
                            order: 2,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'Type',
                                    type: 'div',
                                    className: 'col-md-10 col-12',
                                    sub: {
                                        type: 'div',
                                        className: 'col-md-10 col-12',
                                    }
                                },]
                        },
                        {
                            order: 3,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Value',
                                type: 'div',
                                className: 'col-md-10 col-12',
                                sub: {
                                    type: 'div',
                                    className: 'col-md-10 col-12',
                                }
                            },]
                        },
                        {
                            order: 4,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'Status',
                                type: 'div',
                                className: 'col-md-10 col-12',
                                sub: {
                                    type: 'div',
                                    className: 'col-md-10 col-12',
                                }
                            },]
                        },
                        {
                            order: 5,
                            type: 'div',
                            className: 'row',
                            components: [{
                                name: 'CreatedOn',
                                type: 'div',
                                className: 'col-6',
                                sub: {
                                    type: 'div',
                                    className: 'col-6'
                                }
                            },
                            {
                                name: 'CreatedByName',
                                type: 'div',
                                className: 'col-6',
                                sub: {
                                    type: 'div',
                                    className: 'col-6'
                                }
                            },
                            ]
                        },
                        {
                            order: 6,
                            type: 'div',
                            className: 'row',
                            components: [
                                {
                                    name: 'UpdatedOn',
                                    type: 'div',
                                    className: 'col-6',
                                    sub: {
                                        type: 'div',
                                        className: 'col-6'
                                    }
                                },
                                {
                                    name: 'UpdatedByName',
                                    type: 'div',
                                    className: 'col-6',
                                    sub: {
                                        type: 'div',
                                        className: 'col-6'
                                    }
                                },]
                        },
                    ],
                },
                values: {
                    Name: '',
                    Description: '',
                    Type: '',
                    Value: '',
                    UpdatedByName: '',
                    CreatedByName: '',
                    UpdatedOn: '',
                    CreatedOn: '',
                    UpdatedBy: '',
                    CreatedBy: '',
                    Id: '',
                    editInfo: null,
                    allgriddata: null,
                    navigation: null,
                    CanEdit: '',
                    Key: '',
                    Status: ''
                },

                "components": {
                    Name: {
                        "type": "label",
                        "key": "Name",
                        "label": "Name",
                        "name": "Name",
                        changefieldto: "textfield",
                    },
                    Description: {
                        "type": "label",
                        "key": "Description",
                        "label": "Description",
                        "name": "Description",
                        changefieldto: "textfield",
                        multiline: true
                    },
                    Type: {
                        "type": "label",
                        "key": "Type",
                        "label": "Type",
                        "name": "Type",
                        changefieldto: "dropdown",
                        extraProps: {
                            transformProps: {
                                label: 'Name',
                                value: 'Value'
                            },
                        }
                    },
                    Value: {
                        "type": "label",
                        "key": "Value",
                        "label": "Value",
                        "name": "Value",
                        changefieldto: "textfield",
                    },
                    Status: {
                        "type": "label",
                        "key": "Status",
                        "label": "Status",
                        "name": "Status",
                        changefieldto: "toggle",
                        extraProps: {
                            "transformProps": {
                                "A": true,
                                "I": false,
                                "true": "A",
                                "false": "I"
                            }
                        }
                    },
                    CreatedOn: {
                        "type": "label",
                        "key": "CreatedOn",
                        "label": "Created On",
                        name: "CreatedOn",
                        changefieldto: "label",
                    },
                    CreatedByName: {
                        "type": "label",
                        "key": "CreatedByName",
                        "label": "Created By",
                        name: "CreatedByName",
                        changefieldto: "label",
                    },
                    UpdatedOn: {
                        "type": "label",
                        "key": "UpdatedOn",
                        "label": "Updated On",
                        name: "UpdatedOn",
                        changefieldto: "label",
                    },
                    UpdatedByName: {
                        "type": "label",
                        "key": "UpdatedByName",
                        "label": "Updated By",
                        name: "UpdatedByName",
                        changefieldto: "label",
                    },
                },
                mapActionsToEffects: {
                    'onLoad': {
                        'init': {
                            rules: [{
                                run:
                                {
                                    valid: [{
                                        type: 'load',
                                        name: 'Type',
                                        "read": [
                                            {
                                                url: getEnvVariable('Admin') + `/api/Domains/values?domainkey=SETTING_TYPE`,
                                                type: 'get',
                                                saveAs: {
                                                    key: 'items'
                                                }
                                            }
                                        ]
                                    },

                                    {
                                        type: 'validations',
                                        "read": [
                                            {
                                                "url": getEnvVariable('MasterAdmin') + `/api/ProjectMessages/RulesByName?name=master.appsettings`,
                                                type: 'get'
                                            }
                                        ],
                                        transformProps: {
                                            removesubfieldname: 'MASTER.APPSETTINGS_'
                                        }
                                    },
                                    ]
                                }
                            }]
                        }
                    },
                    'onChange': {
                        'exitfullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'exitfullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'fullscreen': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'fullscreen',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'createduplicate': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'createduplicate',

                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'navigation': {
                            rules: [{
                                run:
                                {
                                    valid: [
                                        {
                                            type: 'initial',
                                            "read": [
                                                {
                                                    url: getEnvVariable('Admin') + `/api/AppSettings/{Id}`,
                                                    key: 'save',
                                                    "matchProps": [
                                                        {
                                                            name: "routeid1",
                                                            key: "routeid1",
                                                        },
                                                        {
                                                            name: "navigation.Id",
                                                            key: "Id",
                                                        }
                                                    ],
                                                    type: 'get',
                                                }
                                            ]
                                        },
                                    ]
                                }
                            }]
                        },
                        'edit': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'edit',

                                            },

                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    'afterSave': {
                        'saveduplicate': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/AppSettings/Add`,
                                                        type: 'post',
                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                        'save': {
                            rules: [
                                {
                                    run: {
                                        valid: [
                                            {
                                                type: 'save',
                                                "read": [
                                                    {
                                                        "url": getEnvVariable('Admin') + `/api/AppSettings/Update`,
                                                        type: 'put',

                                                    }
                                                ],
                                            },

                                        ]
                                    }
                                }
                            ]
                        },
                    }
                }
            }
        },

    }
}

export default GeneralsettingsEdit